export function uploadDocumentToS3(uuid, documentToUpload) {
  const uploadPath = `uploads/${uuid}/${documentToUpload.name}`;
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/createPresignedPost`, {
    method: 'GET',
  })
    .then(res => res.json())
    .then((json) => {
      const body = new FormData();
      body.append('key', uploadPath);
      for (let key in json.data.fields) {
        body.append(key, json.data.fields[key]);
      }
      body.append('file', documentToUpload);

      return fetch(json.data.url, {
        body,
        method: 'POST',
      });
    })
    .then((res) => {
      if (res.ok) {
        return uploadPath;
      }
      return false;
    });
}

export function getUploadUrl(key) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/getSignedUrl`, {
    method: 'POST',
    body: JSON.stringify({ key }),
  })
    .then(res => res.json())
    .then(json => json.url);
}



// WEBPACK FOOTER //
// ./src/services/uploader.js